<template>
    <!-- eslint-disable max-len -->
    <b-row class="p-3">
      <b-col md="6">
        <b-pagination :total-rows="totalRows" :per-page="pagination.perPage" v-model="pagination.currentPage" class="my-0" />
      </b-col>
      <b-col md="6 text-right">
        <label class="my-1">{{(pagination.currentPage - 1) * pagination.perPage + 1}} - {{Math.min(pagination.currentPage * pagination.perPage, totalRows)}} / {{totalRows}}</label>
      </b-col>
    </b-row>
</template>

<script>
export default {
  components: {
  },
  props: {
    pagination: Object,
    totalRows: Number,
  },
  data: () => ({
  }),
};
</script>

<style>
.page-link {
    border: 0 !important;
    width: 34px;
    text-align: center;
    border-radius: 3px;
}
</style>
